import React from 'react';
import { di } from 'react-magnetic-di';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { UiModificationContextContainer } from '../adjustments-context';
import { LoadedUiModificationsContainer } from '../issue-adjustments/container';
import { useLoadViewConfiguration } from '../view-configuration/store';
export var BaseUiModificationsContainer = function BaseUiModificationsContainer(_ref) {
  var children = _ref.children,
    scope = _ref.scope,
    viewType = _ref.viewType,
    viewConfiguration = _ref.viewConfiguration;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useLoadViewConfiguration(viewType, viewConfiguration);
  return /*#__PURE__*/React.createElement(LoadedUiModificationsContainer, {
    scope: scope,
    viewType: viewType,
    createAnalyticsEvent: createAnalyticsEvent
  }, /*#__PURE__*/React.createElement(UiModificationContextContainer, {
    scope: scope
  }, children));
};